import styled from '@emotion/styled';

import React from 'react';
import { Global } from '@emotion/core';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MIXIN_ANCHOR_BUTTON } from 'src/web/components/Style/mixins';
import { POPOVER_Z_INDEX } from 'src/web/components/Style/zindex';
import { Tabs, TabPane } from '../../components/Tabs/EnhancedTabs/component';
import {
  OL_COLOUR_BLACK_90,
  OL_COLOUR_TOMAHTO,
  OL_COLOUR_BLACK_55,
  OL_COLOUR_BLACK_10,
  OL_COLOUR_BLACK_4,
  OL_COLOUR_KELP,
  OL_COLOUR_HIGHLIGHT,
  OL_COLOUR_NAVY_BABY,
} from '../../components/Style/colours';
import { AlertMessage } from '../../components/AlertMessage/component';

import { TextField } from '../../components/TextField/component';

export const InstitutionSettingsContainer = styled('div')({
  width: 1240,
  margin: '20px auto',
  display: 'flex',
});

export const SettingsContentContainer = styled('div')({
  background: 'white',
  marginLeft: 20,
  flex: 1,
  padding: 20,
  color: OL_COLOUR_BLACK_90,
  fontSize: 14,
  maxWidth: 980,
});

export const SectionHeader = styled('div')({
  fontSize: 28,
  fontWeight: 600,
  marginBottom: 40,
});

export const StyledTabs = styled(Tabs)({
  '&.rc-tabs': {
    overflow: 'visible',
  },
});

export const StyledTabPane = styled(TabPane)({
  '&:focus': {
    boxShadow: 'none',
  },
});

export const NameEmailInfo = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginRight: 8,
  img: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    marginRight: 10,
  },
});

export const UserEmail = styled('div')({
  color: OL_COLOUR_BLACK_55,
  fontWeight: 400,
});

export const ErrorMessage = styled('div')({
  color: OL_COLOUR_TOMAHTO,
});

export const ContentWrapper = styled('div')({
  paddingTop: 20,
});

export const Header = styled('div')({
  fontWeight: 600,
  fontSize: 20,
  margin: '20px 0',
});

export const StyledTextField = styled(TextField)({
  width: 380,
});

export const FilterWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 20,

  '>*:not(:last-child)': {
    marginRight: 20,
  },
});

export const PaginationContainer = styled('div')({
  margin: '10px 0 40px -10px',
});

export const PendingTeamAlertMessage = styled(AlertMessage)({
  marginBottom: 20,
});

export const EmptyContentWrapper = styled('div')({
  textAlign: 'center',
  padding: '80px 275px',
  h2: {
    color: OL_COLOUR_BLACK_90,
    fontWeight: 600,
    fontSize: 20,
  },
  p: {
    color: OL_COLOUR_BLACK_55,
  },
});

export const AddTeamMember = styled('button')({
  fontSize: 14,
  fontWeight: 700,
  fontFamily: 'inherit',
  backgroundColor: OL_COLOUR_KELP,
  color: 'white',
  padding: '14px 21px',
  border: 'none',
  borderRadius: 4,
  marginTop: 40,
});

export const ActionTableWrapper = styled('div')({
  position: 'relative',
});

export const SpinnerWrapper = styled('div')({
  position: 'absolute',
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: POPOVER_Z_INDEX,
  backgroundColor: 'rgba(255,255,255,0.5)',
});

export const BulkActionButton = styled('button')({
  color: OL_COLOUR_BLACK_90,
  border: `1px solid ${OL_COLOUR_BLACK_55}`,
  borderRadius: '4px',
  fontFamily: 'inherit',
  fontWeight: 600,
  padding: '8px 10px',
});

export const BulkActionSortDownIcon = styled(FontAwesomeIcon)({
  marginLeft: 4,
  marginBottom: 2,
  color: OL_COLOUR_BLACK_55,
});

export const BulkActionContentWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  margin: '8px 0',
  hr: {
    margin: 0,
  },
});

export const BulkActionContentButton = styled('button')({
  ...MIXIN_ANCHOR_BUTTON,
  textAlign: 'left',
  padding: '8px 11px',
  color: OL_COLOUR_BLACK_90,
  fontWeight: 600,
  textDecoration: 'none',
  svg: {
    marginRight: 12,
  },
});

export const GlobalStylingForModal = (
  <Global
    styles={{
      '.react-modal-dialog': {
        width: 600,
        fontSize: 14,
      },
      '.enrol-to-courses': {
        width: 900,
      },
      '.assign-to-courses': {
        width: 1242,
      },
    }}
  />
);

export const StyledTimesButton = styled('button')({
  background: 'transparent',
  border: 'none',
  lineHeight: 1,
});

export const GroupListItem = styled('div')({
  fontSize: 14,
  padding: 20,
  color: OL_COLOUR_BLACK_90,
  display: 'flex',
  justifyContent: 'space-between',

  '&:not(:last-child)': {
    borderBottom: `1px solid ${OL_COLOUR_BLACK_10}`,
  },
});

export const GroupNameHeading = styled(GroupListItem)({
  fontSize: 14,
  background: OL_COLOUR_BLACK_4,
  fontWeight: 600,
});

export const GroupList = styled('div')({
  marginTop: 20,
  border: `1px solid ${OL_COLOUR_BLACK_10}`,
});

export const CourseDetailItem = styled('div')({
  flex: 1,
  img: {
    float: 'left',
    maxWidth: 46,
    height: 32,
    marginRight: 12,
  },
});

export const CourseName = styled('div')({
  fontWeight: 600,
});

export const CoursePath = styled('div')({
  color: OL_COLOUR_BLACK_55,
});

export const TotalSelectedMembers = styled('span')({
  background: OL_COLOUR_HIGHLIGHT,
  borderRadius: '4px',
  padding: 8,
  marginBottom: 16,
  display: 'inline-block',
});

export const QuestionCircleIcon = styled(FontAwesomeIcon)({
  color: OL_COLOUR_NAVY_BABY,
  marginLeft: 8,
  fontSize: 14,
});

export const PopoverContentHeader = styled('div')({
  padding: 20,
  borderBottom: `1px solid ${OL_COLOUR_BLACK_10}`,
  fontSize: 14,
  fontWeight: 600,
});

export const PopoverContentBody = styled('div')({
  padding: 20,
  fontSize: 14,
  maxHeight: 300,
  overflowY: 'auto',
});
